import React from 'react';
import Hero from '../../components/hero/hero';
import Layout from '../../components/layout/layout';

import styles from "./style.module.scss";
import { BASENAME } from "../../constant";


export default function Privacy() {


    return (
        <Layout>
            <Hero
                image={"bg_hero_brands.png"}
                title={"Privacy policy"}
                breadcrumb={[
                    { label: "Home", link: BASENAME },
                    { label: "Privacy policy", link: null }
                ]}

            />
            <section>
                <div className="container">
                    <a href="https://www.iubenda.com/privacy-policy/29122716" class="iubenda-nostyle iubenda-noiframe iubenda-embed iub-no-markup iubenda-noiframe iub-body-embed" title="Privacy Policy">Privacy Policy</a>
                </div>
            </section>

        </Layout>


    );
}

